<template>
  <div class="be-wrapper">
    <navbar></navbar>
    <router-view></router-view>
  </div>
</template>


<script>

import Navbar from '../navbar/Navbar'

export default {
  components: {
    Navbar,
  },
}
</script>

<style lang="scss" scope>
</style>



// WEBPACK FOOTER //
// Auth.vue?4ccb44eb